/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2018 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import { connect } from 'react-redux';
import BookComponent from './BookComponent';
import {addToCollection, reorderCollections, deleteResources, getDRVS, getOMS, reorderCollectionChapters, updateChapterTitle, deletePart, createNewChapter, getBookBuildDetails, fetchPDFURL} from "../../../_thunks/collection.thunk";
import {csgSearch} from "../../../_thunks/search.thunk";
import {resetSearch, resetResourcePDFURL} from "../../../_actions/search.actions";
import {uploadFile, updateAdditionalResourceInfo, getResourceDetails} from "../../../_thunks/upload.thunk";
import {
    clearAdditionalInfo, clearResource,
    initUpload,
    resourceUploadSuccessDataEdit,
    validateAdditionalInfo
} from "../../../_actions/resource.upload.actions";
import {hideModal} from "../../../_actions/modal.actions";

function mapStateToProps(state, props) {
    return {
        bookDetailsActivePage: state.bookDetailsActivePage,
        resourceSearchResult: state.resourceSearchResult,
        component: state.component,
        router: state.router,
        match: props.match,
        collectionChapters: state.collectionChapters,
        activeCollection: state.activeCollection,
        bookBuildContent: state.bookBuildContent,
        resourceUploadData: state.resourceUploadData
    };
}

const mapDispatchToProps = dispatch => {
    return {

        addResourcesToCollection: (collectionId,chapterId,payload) => {
            dispatch(addToCollection(collectionId,chapterId,payload));
        },
        cbeContentSearch: (params) => {
            dispatch(csgSearch(params));
        },
        updateCollectionChapterInfo: (collectionId, chapters) => {
            dispatch(reorderCollections(collectionId, chapters));
        },
        updateCollectionChapters: (collectionId, chapterId, sequence) => {
            dispatch(reorderCollectionChapters(collectionId,chapterId,sequence));
        },
        getDRVs:(collectionId) => {
            return dispatch(getDRVS(collectionId));
        },
        getOMs:(collectionId) => {
            return dispatch(getOMS(collectionId));
        },
        deleteInstance:(collectionId, instance) => {
            dispatch(deleteResources(collectionId,instance));
        },
        removePart: (collectionId, ChappterId, removeResources) => {
            dispatch(deletePart(collectionId,ChappterId,removeResources));
        },
        resetSearchData: () => {
            dispatch(resetSearch());
        },
        resetPDFURL: () => {
            dispatch(resetResourcePDFURL());
        },
        updateTitle: (collectionId, ChappterId, title) => {
            return dispatch(updateChapterTitle(collectionId, ChappterId, title));
        },
        createPart: (collectionId, payload) => {
            return dispatch(createNewChapter(collectionId,payload));
        },
        getBookBuildContent: (collectionId) => {
            dispatch(getBookBuildDetails(collectionId));
        },
        uploadFile: (params, formData) => {
            return dispatch(uploadFile(params, formData));
        },
        updateAdditionalResourceInfo: (options, requestBody) => {
            return dispatch(updateAdditionalResourceInfo(options, requestBody));
        },
        resourceUploadSuccessDataEdit: (key, value) => {
            const successObj = {
                key: key,
                value: value
            };
            dispatch(resourceUploadSuccessDataEdit(successObj));
        },
        validateAdditionalInfo: (isValid) => {
            dispatch(validateAdditionalInfo(isValid));
        },
        uploadContent: (init) => {
            dispatch(initUpload(init));
        },
        clearAdditionalInfo: (payload) => {
            dispatch(clearAdditionalInfo(payload));
        },
        closeModal : () => {
            dispatch(hideModal());
        },
        getResource : (options) => {
            dispatch(getResourceDetails(options));
        },
        clearResource : () => {
            dispatch(clearResource());
        },
        fetchPDFURL: (resourceId) => {
            dispatch(fetchPDFURL(resourceId));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(BookComponent);



// WEBPACK FOOTER //
// ./src/components/pages/BookContainer/BookComponentLink.js